import { type RouteObject } from 'react-router'

import { AgentCreatePage } from 'features/trend-detection/features/agent-list/AgentCreatePage'
import { AgentsListPage } from 'features/trend-detection/features/agent-list/AgentsListPage'
import { BenchmarkingAgentDetailPage } from 'features/trend-detection/features/benchmarking-agent/BenchmarkingAgentDetailPage'
import { BenchmarkingInsightDetailPage } from 'features/trend-detection/features/benchmarking-agent/BenchmarkingInsightDetailPage'
import { AgentDetailPage } from 'features/trend-detection/features/insight-agent/features/agent-config/Container'
import { AgentInsightDetailPage } from 'features/trend-detection/features/insight-agent/features/insight-detail/Container'
import { IssueAgentDetailPage } from 'features/trend-detection/features/issue-agent-detail/Container'
import { IssueDetailPage } from 'features/trend-detection/features/issue-detail/IssueDetailPage'
import { UpdateDetailPage } from 'features/trend-detection/features/issue-detail/UpdateDetailPage'
import { IssueFeed } from 'features/trend-detection/features/issue-feed/Container'
import { LegacyIssueAgentRedirect } from 'features/trend-detection/LegacyIssueAgentRedirect'
import {
  AGENTS_URL,
  TREND_DETECTION_AGENT_CONFIG_TRANSACTION_PATH,
  TREND_DETECTION_AGENTS_TRANSACTION_PATH,
  TREND_DETECTION_BENCHMARKING_AGENT_TRANSACTION_PATH,
  TREND_DETECTION_INSIGHT_AGENT_DETAIL_TRANSACTION_PATH,
  TREND_DETECTION_INSIGHT_AGENT_TRANSACTION_PATH,
  TREND_DETECTION_ISSUE_DETAIL_TRANSACTION_PATH,
  TREND_DETECTION_LEGACY_URL,
  TREND_DETECTION_TRANSACTION_PATH,
  TREND_DETECTION_UPDATE_DETAIL_TRANSACTION_PATH,
  TREND_DETECTION_URL,
} from 'features/trend-detection/paths'

export const trendDetectionRoutes: RouteObject[] = [
  {
    path: TREND_DETECTION_URL,
    element: <IssueFeed />,
    handle: {
      featureKey: TREND_DETECTION_URL,
      sentryTransactionPath: TREND_DETECTION_TRANSACTION_PATH,
    },
  },
  {
    path: `${TREND_DETECTION_URL}/issues/:issueUuid`,
    element: <IssueDetailPage />,
    handle: {
      featureKey: TREND_DETECTION_URL,
      sentryTransactionPath: TREND_DETECTION_ISSUE_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${TREND_DETECTION_URL}/updates/:updateUuid`,
    element: <UpdateDetailPage />,
    handle: {
      featureKey: TREND_DETECTION_URL,
      sentryTransactionPath: TREND_DETECTION_UPDATE_DETAIL_TRANSACTION_PATH,
    },
  },
  {
    path: `${TREND_DETECTION_URL}/agent-insights/:insightUuid`,
    element: <AgentInsightDetailPage />,
    handle: {
      featureKey: TREND_DETECTION_URL,
      sentryTransactionPath:
        TREND_DETECTION_INSIGHT_AGENT_DETAIL_TRANSACTION_PATH,
      TREND_DETECTION_INSIGHT_AGENT_TRANSACTION_PATH,
    },
  },
  {
    path: `${TREND_DETECTION_URL}/benchmarking-insights/:insightId`,
    element: <BenchmarkingInsightDetailPage />,
    handle: {
      featureKey: TREND_DETECTION_URL,
      sentryTransactionPath: TREND_DETECTION_TRANSACTION_PATH,
    },
  },
  {
    path: AGENTS_URL,
    element: <AgentsListPage />,
    handle: {
      featureKey: AGENTS_URL,
      sentryTransactionPath: TREND_DETECTION_AGENTS_TRANSACTION_PATH,
    },
  },
  {
    path: `${AGENTS_URL}/create`,
    element: <AgentCreatePage />,
    handle: {
      featureKey: AGENTS_URL,
      sentryTransactionPath: TREND_DETECTION_AGENTS_TRANSACTION_PATH,
    },
  },
  {
    path: `${AGENTS_URL}/reports/:agentUuid`,
    element: <AgentDetailPage />,
    handle: {
      featureKey: AGENTS_URL,
      sentryTransactionPath: TREND_DETECTION_INSIGHT_AGENT_TRANSACTION_PATH,
    },
  },
  {
    path: `${AGENTS_URL}/benchmarking/:agentId`,
    element: <BenchmarkingAgentDetailPage />,
    handle: {
      featureKey: AGENTS_URL,
      sentryTransactionPath:
        TREND_DETECTION_BENCHMARKING_AGENT_TRANSACTION_PATH,
    },
  },
  {
    path: `${AGENTS_URL}/:agentId`,
    element: <IssueAgentDetailPage />,
    handle: {
      featureKey: AGENTS_URL,
      sentryTransactionPath: TREND_DETECTION_AGENT_CONFIG_TRANSACTION_PATH,
    },
  },
  // Parameterized variants before the splat fallback so Sentry derives
  // `:insightId` / `:agentId` / `:issueUuid` transaction names instead of `*`.
  // The redirect component reads `location.pathname` directly, so the named
  // params don't need to be threaded through.
  {
    path: `${TREND_DETECTION_LEGACY_URL}/benchmarking-insights/:insightId`,
    element: <LegacyIssueAgentRedirect />,
  },
  {
    path: `${TREND_DETECTION_LEGACY_URL}/benchmarking-agents/:agentId`,
    element: <LegacyIssueAgentRedirect />,
  },
  {
    path: `${TREND_DETECTION_LEGACY_URL}/agents/:agentId`,
    element: <LegacyIssueAgentRedirect />,
  },
  {
    path: `${TREND_DETECTION_LEGACY_URL}/issues/:issueUuid`,
    element: <LegacyIssueAgentRedirect />,
  },
  {
    path: `${TREND_DETECTION_LEGACY_URL}/updates/:updateUuid`,
    element: <LegacyIssueAgentRedirect />,
  },
  {
    path: `${TREND_DETECTION_LEGACY_URL}/*`,
    element: <LegacyIssueAgentRedirect />,
  },
]
